import { all } from 'redux-saga/effects';

import bookingAMC360Saga from './booking-amc360-saga';

export default function* rootSaga() {
  yield all([bookingAMC360Saga()]);
}
